import { render, staticRenderFns } from "./CardConfig.vue?vue&type=template&id=de477520&"
import script from "./CardConfig.vue?vue&type=script&lang=js&"
export * from "./CardConfig.vue?vue&type=script&lang=js&"
import style0 from "./CardConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports